import { CreateNewFolderIcon, LoadingButton, TextField, Typography } from "@firecms/ui";
import { useState } from "react";

import { INVALID_FOLDER_NAME_MESSAGE } from "../../WebDownloadsManager.constants";
import { sanitizeFolderName } from "../../WebDownloadsManager.utils";
import { type ExplorerToolbarProps } from "../../WebDownloadsManager.types";

const ExplorerToolbar: React.FC<ExplorerToolbarProps> = ({ uploading, creatingFolder, deleting, onCreateFolder }) => {
  const [folderName, setFolderName] = useState("");
  const [folderError, setFolderError] = useState(false);

  const handleCreateFolder = async (): Promise<void> => {
    const sanitizedName = sanitizeFolderName(folderName);
    if (!sanitizedName) {
      setFolderError(true);
      return;
    }

    const created = await onCreateFolder(sanitizedName);
    if (created) {
      setFolderName("");
      setFolderError(false);
    }
  };

  const isDisabled = creatingFolder || uploading || deleting;

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="label" className="font-medium">
        Neuer Ordner
      </Typography>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <TextField
          className="w-full sm:max-w-xs"
          size="medium"
          placeholder="z. B. handbooks"
          value={folderName}
          error={folderError}
          disabled={isDisabled}
          onChange={(event) => {
            setFolderName(event.target.value);
            setFolderError(false);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              void handleCreateFolder();
            }
          }}
        />
        <LoadingButton
          variant="outlined"
          color="primary"
          size="medium"
          loading={creatingFolder}
          disabled={isDisabled}
          startIcon={<CreateNewFolderIcon />}
          onClick={() => {
            void handleCreateFolder();
          }}
        >
          Ordner erstellen
        </LoadingButton>
      </div>

      {folderError ? <Typography className="text-sm text-red-600">{INVALID_FOLDER_NAME_MESSAGE}</Typography> : null}
    </div>
  );
};

export default ExplorerToolbar;
